<template>
  <div class="show-serve">
    <table class="table">
      <tbody>
        <tr>
          <td class="label-col">Автомобиль</td>
          <td v-if="car">{{ car.brand }} {{ car.model }}</td>
        </tr>
        <tr>
          <td>Гос. номер</td>
          <td v-if="car">{{ car.registration_plate }}</td>
        </tr>
        <tr>
          <td>Текущий пробег, км</td>
          <td v-if="car">
            {{
              actualOdometer + " км "
            }}
            <span v-if="car.lastState && car.lastState.totalOdometer">(по датчику
            {{
             ' ' + car.lastState
                ? Math.round(car.lastState.totalOdometer.value / 1000) + " км)"
                : "-"
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <hr class="mb-4" />
  </div>
</template>

<script>
import odometerCorrectionApi from '@/api/odometercorrection'

export default {
  name: 'ServivceShow',
  props: ['car'],
  watch: {
    car: {
      handler (car, carOld) {
        if (car?.id !== carOld?.id) {
          odometerCorrectionApi.getActualOdometer({ id: this.car.id })
            .then(odometer => {
              this.actualOdometer = odometer
            })
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      actualOdometer: 0
    }
  }
}
</script>

<style scoped>
  .show-serve {
    margin-top: 4rem;
  }
  .label-col {
    width: 25%;
  }
</style>
